module.exports = __webpack_public_path__ + "img/9788963716329.78ef6394.jpg";